(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stage-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COOKIE_NAME = 'beimli_scratch_seen';
  var COOKIE_DAYS = 5;
  var DISCOUNTS = {
    planning: { pct: '10% off', code: 'IMLI10' },
    pregnant: { pct: '12% off', code: 'JUSTFORYOU' },
    mom: { pct: '12% off', code: 'JUSTFORYOU' },
    browsing: { pct: '10% off', code: 'IMLI10' }
  };
  var stage = null;
  var trimester = null;
  var isSubmitting = false;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
  }

  if (getCookie(COOKIE_NAME)) return;

  var overlay = document.getElementById('beimli-scratch-popup');
  if (!overlay) return;
  if (overlay.dataset.hide === 'true') return;

  if (overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }

  var shown = false;

  function showPopup() {
    if (shown) return;
    shown = true;
    overlay.style.display = 'flex';
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
  }

  function closePopup() {
    overlay.style.display = 'none';
  }

  document.getElementById('beimliScratchClose').addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  var scrollTimer = null;
  function onFirstScroll() {
    if (scrollTimer || shown) return;
    scrollTimer = setTimeout(showPopup, 5000);
    window.removeEventListener('scroll', onFirstScroll);
  }
  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var step1 = document.getElementById('beimliStep1');
  var step2 = document.getElementById('beimliStep2');
  var step3 = document.getElementById('beimliStep3');
  var pctInline = document.getElementById('beimliPctInline');
  var trimesterRow = document.getElementById('beimliTrimesterRow');
  var tagsField = document.getElementById('beimliTagsField');
  var form = document.getElementById('beimli-scratch-form');
  var submitBtn = document.getElementById('beimliScratchSubmitBtn');

  document.querySelectorAll('.beimli-stage-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      stage = btn.dataset.stage;
      var d = DISCOUNTS[stage];
      pctInline.textContent = d.pct;
      step1.style.display = 'none';
      step2.style.display = 'block';
      if (stage === 'pregnant') {
        trimesterRow.style.display = 'block';
      }
    });
  });

  document.querySelectorAll('.beimli-tri-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      trimester = btn.dataset.t;
      document.querySelectorAll('.beimli-tri-btn').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
    });
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (isSubmitting) return false;
      isSubmitting = true;
      if (submitBtn) submitBtn.disabled = true;

      var errorEl = form.querySelector('.beimli-scratch-error');
      if (errorEl) errorEl.style.display = 'none';

      var tags = ['popup-signup'];
      if (stage) tags.push('life-stage-' + stage);
      if (stage === 'pregnant' && trimester) tags.push('trimester-' + trimester);
      tagsField.value = tags.join(', ');

      function resetSubmitState() {
        isSubmitting = false;
        if (submitBtn) submitBtn.disabled = false;
      }

      function completeSignup() {
        var d = DISCOUNTS[stage] || DISCOUNTS.browsing;
        document.getElementById('beimliScratchCodeText').textContent = d.code;
        step2.style.display = 'none';
        step3.style.display = 'block';
      }

      var actionUrl = form.action || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'contact' : '/contact');

      fetch(actionUrl, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (response.redirected || response.ok) {
            return response.json().catch(function () { return {}; });
          }
          return { errors: true };
        })
        .then(function (data) {
          resetSubmitState();
          if (data && data.errors && !(data.errors === true)) {
            if (errorEl) errorEl.style.display = 'block';
            return;
          }
          completeSignup();
        })
        .catch(function () {
          resetSubmitState();
          completeSignup();
        });

      return false;
    });
  }

  var copyBtn = document.getElementById('beimliScratchCopy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = document.getElementById('beimliScratchCodeText').textContent;
      navigator.clipboard.writeText(code).then(function () {
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
